import {FC} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import { TableTyCWrapper } from '../components/tables/TableTyC'
const HeaderTyCPanel: FC = () => {
  return (
    <>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de TyC</Tab>
          </TabList>
          <TabPanel><TableTyCWrapper /></TabPanel>
        </Tabs>
      </div>
    </>
  )
}

export {HeaderTyCPanel}
